import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";
import { snakeCaseObjectToCamelCase } from "../../utils/convert-case";

const replaceBillingProfileWithNew = (apiUrl) => (id, data) => {
  const url = joinUrl(
    apiUrl,
    `/checkoutservice/pb/billing-profiles/${id}/replace-with-new/`
  );
  return requestUtility.post(url, data).then(snakeCaseObjectToCamelCase);
};

export default replaceBillingProfileWithNew;
